<template>
  <b-container class="mb-4">
      <b-card>
        <b-row>
            <b-col>
                <b-form @submit.prevent="createProfessionals()">
                    <b-row>
                        <b-col>
                            <b-form-group label="Sucursal">
                                <b-form-select plain v-model="form.subsidiary_id" :options="subsidiaryNameList" class="mt-1">
                                    <template v-slot:first>
                                    <b-form-select-option :value="null">Listado de Sucursales</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-group label="Tipo de documento">
                                <b-form-select plain v-model="form.document_type" :options="document_types" class="mt-1">
                                    <template v-slot:first>
                                    <b-form-select-option :value="null">Tipo de documento</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group label="Número documento">
                                <b-form-input v-model="form.document_number" type="text"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col>
                            <b-form-group label="Nombres">
                                <b-form-input v-model="form.firstName" type="text" ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group label="Apellidos">
                                <b-form-input v-model="form.lastName" type="text" ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group label="Genero">
                                <b-form-select plain v-model="form.gender" :options="genders" class="mt-1">
                                    <template v-slot:first>
                                    <b-form-select-option :value="null">Genero</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-group label="Dirección">
                                 <b-form-input v-model="form.address" type="text" ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group label="Teléfono">
                                <b-form-input v-model="form.phone_number" type="text" ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group label="Correo Electrónico">
                                <b-form-input v-model="form.email" type="text" ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>    
                    <b-row>
                        <b-col>
                            <b-form-group label="Profesión">
                                <b-form-select plain v-model="form.profession_type_id" :options="professions_types" class="mt-1">
                                    <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>Profesión</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-row> 
                    <b-button type="submit" variant="primary">Crear profesional</b-button>
                    <b-button @click="cancel" variant="none" class="iq-bg-danger ml-3">Cancelar</b-button>
                </b-form>
            </b-col>
        </b-row>
      </b-card>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import axios from 'axios'
import firebase from 'firebase'

export default {
  name: 'Entrenadores',
  data () {
    return {
      form: {
        subsidiary_id: '',
        document_type: '',
        document_number: '',
        firstName: '',
        lastName: '',
        gender: '',
        phone_number: '',
        email: '',
        profession_type_id: '',
        photo: '',
        address:'',
        company_id: '',
      },
      document_types: ['Cedula', 'Pasaporte'],
      genders: ['Hombre', 'Mujer'],
      modalities: ['Uno', 'Dos'],
      professions: null,
      professions_types: [],
      sports: null,
      sports_types: [],
      subsidiaryNameList: [],
      subsidiaryList: []
    }
  },
  methods: {
    createProfessionals () {
        if(this.form){
            // Set profession type id
            const profId = this.form.profession_type_id;
            this.form.profession_type_id = this.professions.filter(e => e.item.name === profId)[0].item.id;

            const subsidiaryId = this.form.subsidiary_id;
            this.form.subsidiary_id = this.subsidiaryList.filter(e => e.item.name === subsidiaryId)[0].item.id
            // set company id
            this.form.company_id = JSON.parse(localStorage.getItem('atpro_cd')).id;

            console.log("form", this.form)
        }
         axios.post('https://us-central1-atpro-app.cloudfunctions.net/api/professionals/create', this.form)
                .then(r => {
                this.$router.push({ name: 'atpro.professionals-list' })
                })
                .catch(e => {
                console.error('Error Couch', e)
                })
    },

    getProfessions(){
        axios.get('https://us-central1-atpro-app.cloudfunctions.net/api/professions/all')
        .then(r => {
            // console.log('✅ All professions', r.data.data)
            this.professions = r.data.data;
            console.log("get professions", this.professions)
            r.data.data.forEach(e => {
                this.professions_types.push(e.item.name);
            });
        })
        .catch(e => {
          console.error('Error getting professions', e)
        })
    },

    async getSubsidiaryListByCompany() {
      this.loading = true;
      const company = JSON.parse(localStorage.getItem("atpro_cd"));
      const {data: { data }} = await axios.get(`https://us-central1-atpro-app.cloudfunctions.net/api/subsidiary/byCompany/${company.id}`)
     this.subsidiaryList= data;;
     for(const i of data){
        this.subsidiaryNameList.push(i.item.name);
        this.loading = false;
     }
     
    },
    
    cancel () {
      this.$router.push({ path: 'coaches' })
    }


  },
  created(){
      this.getProfessions();
      this.getSubsidiaryListByCompany();
  },
  mounted () {
    core.index()
  }
}
</script>
